exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./apps-ts/outputs/src/app/newsletters/newsletter-data-table/newsletter-data-table.component.css
 ** module id = 31
 ** module chunks = 0 1
 **/